"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tslib = require("tslib");

var _map2 = _interopRequireDefault(require("lodash/map"));

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));

var _api = require("@lce/api");

var _analytics = require("@lce/analytics");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable max-lines-per-function */
// tslint:disable-next-line
var provider = typeof window !== 'undefined' && window.sessionStorage;
var useCartState = (0, _api.createPersistedState)('cart', provider); // eslint-disable-next-line max-lines-per-function

var useCart = function useCart() {
  var _a = useCartState({}),
      cart = _a[0],
      setCart = _a[1];

  var addCustom = function addCustom(item, customTicketId, quantity) {
    var _a;

    if (quantity === void 0) {
      quantity = 1;
    }

    if (quantity > 99) {
      return;
    }

    var updatedItem = (0, _tslib.__assign)((0, _tslib.__assign)({}, cart), (_a = {}, _a[customTicketId] = (0, _tslib.__assign)((0, _tslib.__assign)({
      menuItemId: item.menuItemCode
    }, item), {
      customTicketId: customTicketId,
      quantity: quantity
    }), _a));
    (0, _map2["default"])(cart, function (cartItem) {
      var _a;

      var customCart = (0, _omit2["default"])(cartItem, ['customTicketId', 'menuItemId', 'quantity']);
      var customItem = (0, _omit2["default"])(item, ['customTicketId', 'menuItemId', 'quantity']);

      if ((0, _isEqual2["default"])(customCart, customItem)) {
        // tslint:disable
        var updatedQty = cartItem.quantity + quantity; // tslint:enable

        if (updatedQty > 99) {
          return;
        }

        updatedItem = (0, _tslib.__assign)((0, _tslib.__assign)({}, cart), (_a = {}, _a[cartItem.customTicketId] = (0, _tslib.__assign)((0, _tslib.__assign)({}, cartItem), {
          quantity: updatedQty
        }), _a));
      }
    });

    _analytics.GoogleEvents.addToCart({
      id: item.menuItemCode,
      name: item.itemName,
      price: item.price,
      quantity: quantity,
      category: 'Custom Pizza'
    });

    return setCart(updatedItem);
  };

  var add = function add(item, quantity) {
    var _a;

    if (quantity === void 0) {
      quantity = 1;
    }

    var updatedItem = (0, _tslib.__assign)({}, item);
    var updatedQty = quantity;
    var currentItem = cart && cart[item.menuItemCode];

    if (currentItem) {
      updatedItem = currentItem; // tslint:disable

      updatedQty = currentItem.quantity + quantity; // tslint:enable
    }

    if (updatedQty > 99) {
      return;
    }

    _analytics.GoogleEvents.addToCart({
      id: item.menuItemCode,
      name: item.itemName,
      price: item.price,
      quantity: quantity,
      category: (item === null || item === void 0 ? void 0 : item.typeDescription) || ''
    });

    return setCart((0, _tslib.__assign)((0, _tslib.__assign)({}, cart), (_a = {}, _a[updatedItem.menuItemCode] = (0, _tslib.__assign)((0, _tslib.__assign)({}, updatedItem), {
      // tslint:disable-next-line
      quantity: typeof updatedQty === 'string' ? parseInt(updatedQty, 10) : updatedQty
    }), _a)));
  };

  var addItems = function addItems(items, quantity) {
    if (quantity === void 0) {
      quantity = 1;
    }

    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
      return (0, _tslib.__generator)(this, function (_a) {
        return [2
        /*return*/
        , setCart((0, _tslib.__assign)((0, _tslib.__assign)({}, cart), (0, _keyBy2["default"])((0, _map2["default"])(items, function (item) {
          var menuItems = items.filter(function (menuItem) {
            return menuItem.menuItemCode === item.menuItemCode;
          });
          var hasSameItems = item.menuItemCode === menuItems[0].menuItemCode;
          return (0, _tslib.__assign)((0, _tslib.__assign)({}, item), {
            quantity: hasSameItems ? menuItems.length : quantity
          });
        }), 'menuItemCode')))];
      });
    });
  };

  var addPreviousOrder = function addPreviousOrder(items) {
    var updatedItems = (0, _map2["default"])(items, function (item) {
      var _a;

      var updatedItem = (0, _tslib.__assign)((0, _tslib.__assign)({}, item), {
        menuItemId: item.menuItemCode,
        itemCaloriesText: item.calories + " Cal"
      });
      var updatedQty = item.quantity;

      if (updatedQty > 99) {
        return;
      }

      if (updatedItem.customTicketId === 0) {
        updatedItem.customTicketId = null;
      } else if (updatedItem.customTicketId) {
        updatedItem.menuItemId = updatedItem.customTicketId.toString();
      }

      return _a = {}, _a[updatedItem.menuItemId] = (0, _tslib.__assign)((0, _tslib.__assign)({}, updatedItem), {
        // tslint:disable-next-line
        quantity: typeof updatedQty === 'string' ? parseInt(updatedQty, 10) : updatedQty
      }), _a;
    });

    var createObjectFromArray = function createObjectFromArray(array) {
      var object = {};
      (0, _map2["default"])(array, function (item) {
        object = (0, _tslib.__assign)((0, _tslib.__assign)({}, object), item);
      });
      return object;
    };

    var previousOrderItems = createObjectFromArray(updatedItems);
    return setCart((0, _tslib.__assign)((0, _tslib.__assign)({}, cart), previousOrderItems));
  };

  var remove = function remove(menuItemCode) {
    var updatedCart = (0, _tslib.__assign)({}, cart);
    delete updatedCart[menuItemCode];
    return setCart(updatedCart);
  };

  var setQuantity = function setQuantity(menuItemCode, quantity) {
    var _a;

    if (!cart[menuItemCode]) {
      return;
    }

    if (parseInt(quantity, 10) > 99) {
      return;
    }

    if (parseInt(quantity, 10) === 0) {
      return remove(menuItemCode);
    }

    return setCart((0, _tslib.__assign)((0, _tslib.__assign)({}, cart), (_a = {}, _a[menuItemCode] = (0, _tslib.__assign)((0, _tslib.__assign)({}, cart[menuItemCode]), {
      quantity: quantity.length > 0 ? parseInt(quantity, 10) : quantity
    }), _a)));
  };

  var emptyCart = function emptyCart() {
    return setCart({});
  };

  var subtotal = (0, _sum2["default"])((0, _map2["default"])(cart, function (item) {
    return item.price * item.quantity;
  }));
  var count = (0, _sum2["default"])((0, _map2["default"])(cart, function (item) {
    return item.quantity ? parseInt(item.quantity, 10) : 0;
  }));
  return {
    add: add,
    addCustom: addCustom,
    addItems: addItems,
    addPreviousOrder: addPreviousOrder,
    cart: cart,
    count: count,
    emptyCart: emptyCart,
    remove: remove,
    setQuantity: setQuantity,
    subtotal: subtotal
  };
};

var _default = useCart;
exports["default"] = _default;